<template>
  <div :class="`${pageName}-wrapper page-wrapper`">
    <UkaskoLoader :is-loading="!isTextBlocksReady('login') && isLoading">
      <div :class="`${pageName} page`">
        <div class="page-content">
          <BackgroundGridWhite :class="`${pageName}__grid page__grid`">
            <AppHeader />
            <slot />
          </BackgroundGridWhite>
          <div :class="`${pageName}__footer page__footer`"></div>
        </div>
        <AppFooter />
      </div>
    </UkaskoLoader>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { BackgroundGridWhite } from '@/shared/ui/promo';
import { UkaskoLoader } from '@/shared/ui/ukasko-loader';
import { AppFooter, AppHeader } from '@/widgets/login';

export default {
  props: {
    pageName: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.fetchTextBlocks('login');
  },
  components: { UkaskoLoader, AppHeader, AppFooter, BackgroundGridWhite },
  computed: {
    ...mapGetters('textBlocksModule', ['isTextBlocksReady']),
  },
  methods: {
    ...mapActions('textBlocksModule', ['fetchTextBlocks']),
  },
};
</script>

<style lang="scss" scoped>
.ukasko-loader-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &-content {
    position: relative;
    flex: 1;
  }

  &-wrapper {
    font-family: 'Inter', sans-serif;
    background-color: #CADDFC;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 1026'%3E%3Cg filter='url(%23f)'%3E%3Crect x='312' y='117' width='817' height='495' rx='247.5' fill='%23FFF4EA'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='f' x='-102' y='-297' width='1645' height='1323'%3E%3CfeFlood flood-opacity='0' result='bg'/%3E%3CfeBlend in='SourceGraphic' in2='bg' result='shape'/%3E%3CfeGaussianBlur stdDeviation='207' result='blur'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E");
    background-size: cover;
    background-position: 50% 60px;
  }

  &__grid {
    height: 100%;
    padding-bottom: 277px;

    @media (max-width: 630px) {
      padding-bottom: 90px;
    }
  }

  &__footer {
    position: absolute;
    bottom: 0;
    height: 32px;
    width: 100%;
    background-color: #313437;
    border-radius: 32px 32px 0 0;
  }
}
</style>
